export default "__VITE_ASSET__psTpm00F__"